module.exports = __webpack_public_path__ + "static/img/team_honor_area.057c822a.png";